module.exports = __webpack_public_path__ + "688341b4a05f7f2581d92ead17657548.MP3";